import { ref, computed } from "vue";
import { useRouter } from "vue-router"
import { useToast } from "vue-toastification"

import store from "../state/store"

import useSortData from './useSortData';

export default function useUsers(props, emit, userData, walletData) {
    const router = useRouter()

    // Get toast interface
    const toast = useToast()

    const userStatus = ref("")
    const transactionType = ref("")
    const actionType = ref("")
    const search = ref("")
    const createdAtDate = ref("")
    const perPage = ref(10)
    const loading = ref(false)
    const errors = ref({})


    const show = computed({
        get: () => props.modelValue,
        set: (value) => emit("update:modelValue", value),
    })

    const getUsers = (url = null) => {
        store.dispatch("getUsers", {
            url,
            search: search.value,
            status: userStatus.value,
            created_at: createdAtDate.value,
            per_page: perPage.value,
            sort_field: sortField.value,
            sort_direction: sortDirection.value,
        })
    }


    const onSubmit = () => {
        loading.value = true
        if (userData.value.id) {
            store.dispatch('updateUser', userData.value)
                .then(response => {
                    loading.value = false;
                    if (response.status === 200) {
                        toast.success("کاربر با موفقیت به روزرسانی شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getUsers")
                        closeModal()
                    }
                })

        } else {
            store
                .dispatch("createUser", userData.value)
                .then((response) => {
                    loading.value = false
                    if (response.status === 201) {
                        toast.success(" کاربر مورد نظر با موفقیت افزوده شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getUsers")
                        closeModal()
                    }
                })
                .catch((err) => {
                    loading.value = false
                    errors.value = err.response.data.errors
                })
        }
    }

    const updateUserWallet = () => {
        loading.value = true
        store.dispatch("updateWallet", walletData.value)
            .then((response) => {
                loading.value = false
                if (response.status === 201) {

                    closeModal()
                    router.push({
                        name: "users.wallet.transactions",
                        params: { userId: response.data.data.user }
                    })
                    toast.success("کیف پول کاربر موردنظر با موفقیت به روز رسانی شد.", {
                        timeout: 4000,
                    })
                }
            })
            .catch((err) => {
                loading.value = false
                errors.value = err.response.data.errors
            })
    }

    const getWalletTransactions = (userId, url = null) => {
        store.dispatch("getWalletTransactions", {
            userId: userId,
            url,
            transactionType: transactionType.value,
            actionType: actionType.value,
            created_at: createdAtDate.value,
            per_page: perPage.value,
            sort_field: sortField.value,
            sort_direction: sortDirection.value,
        })
    }

    const closeModal = () => {
        show.value = false
        errors.value = {}
        emit("close")
    }

    const { sortField, sortDirection, sortData } = useSortData(getUsers);

    const sortUsers = (field) => {
        sortData(field);
        getUsers();
    };


    return {
        show,
        transactionType,
        actionType,
        userStatus,
        search,
        createdAtDate,
        perPage,
        sortField,
        sortDirection,
        loading,
        errors,
        getUsers,
        getWalletTransactions,
        onSubmit,
        updateUserWallet,
        closeModal,
        sortUsers,
    }
}